(function () {
  'use strict';


  /* =========================================================
     COMPARE MEDIA
     ========================================================= */

  function setCompareMedia(side, thumb) {
  if (!side || !thumb) return;

  var mediaType =
    thumb.getAttribute('data-hc-media-type') || 'image';

  var imageUrl =
    thumb.getAttribute('data-hc-image') || '';

  var videoUrl =
    thumb.getAttribute('data-hc-video') || '';

  var mainMedia =
    side.querySelector('[data-hc-compare-main-media]');

  if (!mainMedia) return;


  /*
   * Stop and remove any previously opened video.
   */
  var oldVideo =
    mainMedia.querySelector('.hc-compare-main-video');

  if (oldVideo) {
    oldVideo.pause();
  }


  /*
   * VIDEO
   */
  if (mediaType === 'video' && videoUrl) {

    mainMedia.innerHTML = '';

    var video = document.createElement('video');

    video.className =
      'hc-compare-main-video';

    video.src = videoUrl;

    video.controls = true;
    video.autoplay = true;
    video.muted = true;
    video.playsInline = true;

    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'metadata');

    mainMedia.appendChild(video);

    var playPromise = video.play();

    if (
      playPromise &&
      typeof playPromise.catch === 'function'
    ) {
      playPromise.catch(function () {
        /* Controls remain available if autoplay is blocked */
      });
    }

  /*
   * IMAGE
   */
  } else if (imageUrl) {

    mainMedia.innerHTML = '';

    var image =
      document.createElement('img');

    image.className =
      'hc-compare-main-image';

    image.src = imageUrl;
    image.alt = '';

    mainMedia.appendChild(image);
  }


  side
    .querySelectorAll('[data-hc-compare-thumb]')
    .forEach(function (item) {
      item.classList.remove('is-active');
    });

  thumb.classList.add('is-active');
}


  /* =========================================================
     IMAGE PRELOAD
     ========================================================= */

  function preloadCompareImages(compareMode) {
    if (!compareMode) return;
    if (compareMode.dataset.hcImagesPreloaded === 'true') return;

    compareMode.dataset.hcImagesPreloaded = 'true';

    var urls = [];

    compareMode.querySelectorAll('[data-hc-compare-thumb]').forEach(function (thumb) {
      var mediaType = thumb.getAttribute('data-hc-media-type') || 'image';
      var imageUrl = thumb.getAttribute('data-hc-image');

      if (
        mediaType !== 'video' &&
        imageUrl &&
        urls.indexOf(imageUrl) === -1
      ) {
        urls.push(imageUrl);
      }
    });

    urls.forEach(function (url) {
      var image = new Image();
      image.src = url;
    });
  }


  function preloadCompareProduct(hero, productId) {
    if (!hero || !productId) return;

    var dataStore = hero.querySelector('[data-hc-compare-data-store]');
    if (!dataStore) return;

    var productData = dataStore.querySelector(
      '[data-hc-compare-product-data][data-product-id="' + productId + '"]'
    );

    if (!productData) return;

    if (productData.dataset.hcPreloaded === 'true') return;

    productData.dataset.hcPreloaded = 'true';

    productData.querySelectorAll('[data-hc-compare-media]').forEach(function (media) {
      var mediaType = media.getAttribute('data-media-type') || 'image';
      var imageUrl = media.getAttribute('data-media-image');

      if (mediaType !== 'video' && imageUrl) {
        var image = new Image();
        image.src = imageUrl;
      }
    });
  }


  /* =========================================================
     BUILD PRODUCT GALLERY
     ========================================================= */

  function rebuildCompareGallery(side, productData) {
    if (!side || !productData) return;

    var mediaItems = Array.from(
      productData.querySelectorAll('[data-hc-compare-media]')
    );

    if (!mediaItems.length) return;

    var firstMedia = mediaItems[0];

    var firstImage =
      firstMedia.getAttribute('data-media-image') || '';

    var mainMedia =
      side.querySelector('[data-hc-compare-main-media]');

    var mainImage =
      mainMedia
        ? mainMedia.querySelector('.hc-compare-main-image')
        : null;

    if (mainImage && firstImage) {
      mainImage.src = firstImage;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
    }


    var thumbs =
      side.querySelector('[data-hc-compare-thumbs]');

    if (!thumbs) return;

    thumbs.innerHTML = '';


    mediaItems.forEach(function (media, index) {
      var mediaType =
        media.getAttribute('data-media-type') || 'image';

      var imageUrl =
        media.getAttribute('data-media-image') || '';

      var videoUrl =
        media.getAttribute('data-media-video') || '';

      if (!imageUrl) return;


      var button = document.createElement('button');

      button.type = 'button';

      button.className =
        'hc-compare-thumb' +
        (index === 0 ? ' is-active' : '');

      button.setAttribute('data-hc-compare-thumb', '');
      button.setAttribute('data-hc-media-type', mediaType);
      button.setAttribute('data-hc-image', imageUrl);

      if (videoUrl) {
        button.setAttribute('data-hc-video', videoUrl);
      }

      button.setAttribute(
        'aria-label',
        'View product media ' + (index + 1)
      );


      var image = document.createElement('img');

      image.className = 'hc-compare-thumb__image';
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';

      button.appendChild(image);
      thumbs.appendChild(button);
    });
  }


  /* =========================================================
     ACTIVE / DISABLED SWATCH STATE
     ========================================================= */

  function updateCompareSwatchStates(compareMode) {
    if (!compareMode) return;

    var leftProduct =
      compareMode.querySelector(
        '.hc-compare-product[data-hc-compare-side="left"]'
      );

    var rightProduct =
      compareMode.querySelector(
        '.hc-compare-product[data-hc-compare-side="right"]'
      );

    if (!leftProduct || !rightProduct) return;

    var leftId =
      leftProduct.getAttribute('data-hc-compare-product-id');

    var rightId =
      rightProduct.getAttribute('data-hc-compare-product-id');


    compareMode
      .querySelectorAll('[data-hc-compare-color-swatch]')
      .forEach(function (swatch) {

        var side =
          swatch.getAttribute('data-hc-compare-side');

        var productId =
          swatch.getAttribute('data-product-id');


        swatch.classList.remove('is-active');
        swatch.classList.remove('is-disabled');

        swatch.disabled = false;


        if (side === 'left') {

          if (productId === leftId) {
            swatch.classList.add('is-active');
          }

          if (productId === rightId) {
            swatch.classList.add('is-disabled');
            swatch.disabled = true;
          }

        }


        if (side === 'right') {

          if (productId === rightId) {
            swatch.classList.add('is-active');
          }

          if (productId === leftId) {
            swatch.classList.add('is-disabled');
            swatch.disabled = true;
          }

        }

      });
  }


  /* =========================================================
     CHANGE LEFT / RIGHT PRODUCT
     ========================================================= */

     function confirmComparePurchaseSide(compareMode, selectedSide) {
  if (!compareMode || !selectedSide) return;

  compareMode.classList.add('is-purchase-confirmed');

  compareMode
    .querySelectorAll('[data-hc-compare-side]')
    .forEach(function (side) {
      var sideName =
        side.getAttribute('data-hc-compare-side');

      side.classList.toggle(
        'is-not-selected-for-purchase',
        sideName !== selectedSide
      );
    });
}

     function resetComparePurchaseState(compareMode) {
  if (!compareMode) return;

  compareMode.classList.remove(
  'is-purchase-confirmed'
);

compareMode
  .querySelectorAll(
    '.is-not-selected-for-purchase'
  )
  .forEach(function (item) {
    item.classList.remove(
      'is-not-selected-for-purchase'
    );
  });

  var addButton = compareMode.querySelector(
    '[data-hc-compare-add-to-cart]'
  );

  var addButtonText = compareMode.querySelector(
    '[data-hc-compare-add-to-cart-text]'
  );

  if (addButton) {
    addButton.disabled = true;
    addButton.setAttribute('aria-disabled', 'true');
  }

  if (addButtonText) {
    addButtonText.textContent =
      'ADD TO BAG';
  }
}

  function changeCompareProduct(hero, compareMode, sideName, productId) {
    if (!hero || !compareMode || !sideName || !productId) return;

    var dataStore =
      hero.querySelector('[data-hc-compare-data-store]');

    if (!dataStore) return;


    var productData =
      dataStore.querySelector(
        '[data-hc-compare-product-data][data-product-id="' +
        productId +
        '"]'
      );

    if (!productData) return;


    var side =
      compareMode.querySelector(
        '.hc-compare-product[data-hc-compare-side="' +
        sideName +
        '"]'
      );

    if (!side) return;


    var productUrl =
      productData.getAttribute('data-product-url') || '';

    var productColor =
      productData.getAttribute('data-product-color') || '';


    side.setAttribute(
      'data-hc-compare-product-id',
      productId
    );

    side.setAttribute(
      'data-hc-compare-product-url',
      productUrl
    );


    if (sideName === 'left') {
      compareMode.setAttribute(
        'data-hc-compare-product-a-id',
        productId
      );

      compareMode.setAttribute(
        'data-hc-compare-product-a-url',
        productUrl
      );
    }


    if (sideName === 'right') {
      compareMode.setAttribute(
        'data-hc-compare-product-b-id',
        productId
      );

      compareMode.setAttribute(
        'data-hc-compare-product-b-url',
        productUrl
      );
    }


    var heading =
      compareMode.querySelector(
        '[data-hc-compare-color-name="' +
        sideName +
        '"]'
      );

    if (heading && productColor) {
      heading.textContent = productColor;
    }

    var reviewRating =
  compareMode.querySelector(
    '[data-hc-compare-review-rating="' +
    sideName +
    '"]'
  );

var reviewCount =
  compareMode.querySelector(
    '[data-hc-compare-review-count="' +
    sideName +
    '"]'
  );

var productReviewRating =
  productData.getAttribute(
    'data-product-review-rating'
  );

var productReviewCount =
  productData.getAttribute(
    'data-product-review-count'
  );

if (reviewRating) {
  reviewRating.textContent =
    productReviewRating || '5';
}

if (reviewCount) {
  reviewCount.textContent =
    productReviewCount || '0';
}

    rebuildCompareGallery(side, productData);

    updateCompareSwatchStates(compareMode);

    resetComparePurchaseState(compareMode);
  }


  /* =========================================================
     COLOR SWATCH CLICKS
     ========================================================= */

  function getCompareProductData(hero, productId) {
  if (!hero || !productId) return null;

  var dataStore = hero.querySelector(
    '[data-hc-compare-data-store]'
  );

  if (!dataStore) return null;

  return dataStore.querySelector(
    '[data-hc-compare-product-data][data-product-id="' +
    productId +
    '"]'
  );
}


function resetCompareOptionsPanel(compareMode) {
  if (!compareMode) return;

  var panel = compareMode.querySelector(
    '[data-hc-compare-options-panel]'
  );

  if (!panel) return;

  panel
    .querySelectorAll('[data-hc-compare-purchase-color]')
    .forEach(function (button) {
      button.classList.remove('is-selected');
    });

  var dynamicOptions = panel.querySelector(
    '[data-hc-compare-dynamic-options]'
  );

  if (dynamicOptions) {
    dynamicOptions.innerHTML = '';
  }

  var done = panel.querySelector(
    '[data-hc-compare-options-done]'
  );

  if (done) {
    done.disabled = true;
    done.setAttribute('aria-disabled', 'true');
    done.removeAttribute('data-product-id');
    done.removeAttribute('data-variant-id');
  }
}


function openCompareOptionsPanel(hero, compareMode) {
  var panel = compareMode.querySelector(
    '[data-hc-compare-options-panel]'
  );

  if (!panel) return;

  resetCompareOptionsPanel(compareMode);
  resetComparePurchaseState(compareMode);

  var leftProduct = compareMode.querySelector(
    '.hc-compare-product[data-hc-compare-side="left"]'
  );

  var rightProduct = compareMode.querySelector(
    '.hc-compare-product[data-hc-compare-side="right"]'
  );

  if (!leftProduct || !rightProduct) return;

  var leftId = leftProduct.getAttribute(
    'data-hc-compare-product-id'
  );

  var rightId = rightProduct.getAttribute(
    'data-hc-compare-product-id'
  );

  var leftData = getCompareProductData(hero, leftId);
  var rightData = getCompareProductData(hero, rightId);

  var leftName = panel.querySelector(
    '[data-hc-compare-purchase-color-name="left"]'
  );

  var rightName = panel.querySelector(
    '[data-hc-compare-purchase-color-name="right"]'
  );

  if (leftName && leftData) {
    leftName.textContent =
      leftData.getAttribute('data-product-color') || '';
  }

  if (rightName && rightData) {
    rightName.textContent =
      rightData.getAttribute('data-product-color') || '';
  }

  panel.hidden = false;
  panel.setAttribute('aria-hidden', 'false');
}


function closeCompareOptionsPanel(compareMode) {
  var panel = compareMode.querySelector(
    '[data-hc-compare-options-panel]'
  );

  if (!panel) return;

  panel.hidden = true;
  panel.setAttribute('aria-hidden', 'true');
}

function buildCompareDynamicOptions(panel, productData) {
  if (!panel || !productData) return;

  var container = panel.querySelector(
    '[data-hc-compare-dynamic-options]'
  );

  if (!container) return;

  container.innerHTML = '';

  var optionNodes = Array.from(
    productData.querySelectorAll('[data-hc-compare-option]')
  );

  if (!optionNodes.length) return;

  optionNodes.forEach(function (optionNode) {
    var optionName =
      optionNode.getAttribute('data-option-name') || '';

    var optionPosition =
      optionNode.getAttribute('data-option-position') || '';

    var group = document.createElement('div');

    group.className = 'hc-compare-dynamic-option-group';

    group.setAttribute(
      'data-hc-compare-dynamic-option-group',
      ''
    );

    group.setAttribute(
      'data-option-position',
      optionPosition
    );


    var label = document.createElement('div');

    label.className = 'hc-compare-dynamic-option-label';

    label.textContent = optionName;

    group.appendChild(label);


    var valuesWrap = document.createElement('div');

    valuesWrap.className =
      'hc-compare-dynamic-option-values';


    optionNode
      .querySelectorAll('[data-hc-compare-option-value]')
      .forEach(function (valueNode) {

        var value =
          valueNode.getAttribute(
            'data-option-value'
          ) || '';

        var button =
          document.createElement('button');

        button.type = 'button';

        button.className =
          'hc-compare-dynamic-option-value';

        button.setAttribute(
          'data-hc-compare-dynamic-option-value',
          ''
        );

        button.setAttribute(
          'data-option-position',
          optionPosition
        );

        button.setAttribute(
          'data-option-value',
          value
        );

        button.textContent = value;

        valuesWrap.appendChild(button);
      });


    group.appendChild(valuesWrap);

    container.appendChild(group);
  });
}


function findCompareVariant(productData, selections) {
  if (!productData) return null;

  var variants = Array.from(
    productData.querySelectorAll(
      '[data-hc-compare-variant]'
    )
  );

  return variants.find(function (variant) {
    var available =
      variant.getAttribute(
        'data-variant-available'
      ) === 'true';

    if (!available) return false;

    for (var i = 1; i <= 3; i++) {
      if (!selections[i]) continue;

      var variantValue =
        variant.getAttribute(
          'data-option-' + i
        ) || '';

      if (variantValue !== selections[i]) {
        return false;
      }
    }

    return true;
  }) || null;
}


function updateCompareOptionsDoneState(panel, productData) {
  if (!panel || !productData) return;

  var groups = Array.from(
    panel.querySelectorAll(
      '[data-hc-compare-dynamic-option-group]'
    )
  );

  var done = panel.querySelector(
    '[data-hc-compare-options-done]'
  );

  if (!done) return;

  var selections = {};
  var allSelected = groups.length > 0;

  groups.forEach(function (group) {
    var position =
      group.getAttribute(
        'data-option-position'
      );

    var selected =
      group.querySelector(
        '[data-hc-compare-dynamic-option-value].is-selected'
      );

    if (!selected) {
      allSelected = false;
      return;
    }

    selections[position] =
      selected.getAttribute(
        'data-option-value'
      );
  });


  if (!allSelected) {
    done.disabled = true;
    done.setAttribute(
      'aria-disabled',
      'true'
    );

    done.removeAttribute(
      'data-variant-id'
    );

    return;
  }


  var variant =
    findCompareVariant(
      productData,
      selections
    );


  if (!variant) {
    done.disabled = true;
    done.setAttribute(
      'aria-disabled',
      'true'
    );

    done.removeAttribute(
      'data-variant-id'
    );

    return;
  }


  var variantId =
    variant.getAttribute(
      'data-variant-id'
    );


  done.setAttribute(
    'data-variant-id',
    variantId
  );

  done.disabled = false;

  done.setAttribute(
    'aria-disabled',
    'false'
  );
}

function submitCompareProduct(hero, compareMode) {
  if (!hero || !compareMode) return;

  var variantId =
    compareMode.getAttribute(
      'data-hc-purchase-variant-id'
    );

  var productId =
    compareMode.getAttribute(
      'data-hc-purchase-product-id'
    );

  if (!variantId || !productId) return;


  var form =
    hero.querySelector(
      '.product-single__form'
    );

  if (!form) {
    form = document.querySelector(
      '.product-single__form'
    );
  }

  if (!form) return;


  var productSelect =
    form.querySelector(
      '[data-product-select]'
    );

  if (!productSelect) return;


  /*
   * The selected Compare variant may belong to
   * another Shopify product and therefore may not
   * exist in the current PDP select.
   */
  var compareOption =
    productSelect.querySelector(
      'option[data-hc-compare-temp-variant]'
    );

  if (compareOption) {
    compareOption.remove();
  }


  compareOption =
    document.createElement('option');

  compareOption.value = variantId;
  compareOption.textContent = 'Compare selected variant';

  compareOption.setAttribute(
    'data-hc-compare-temp-variant',
    ''
  );

  compareOption.selected = true;

  productSelect.appendChild(
    compareOption
  );

  productSelect.value = variantId;


  var normalAddButton =
    form.querySelector(
      '[data-add-to-cart]'
    );

  if (!normalAddButton) return;


  /*
   * The normal PDP button may currently be disabled
   * because its own options were never selected.
   * Compare Mode has already validated its own variant.
   */
  normalAddButton.disabled = false;
  normalAddButton.removeAttribute(
    'disabled'
  );


  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit(
      normalAddButton
    );
  } else {
    normalAddButton.click();
  }
}

function pulseCompareOptionsButton(compareMode) {
  if (!compareMode) return;

  var optionsButton = compareMode.querySelector(
    '[data-hc-compare-config-trigger]'
  );

  if (!optionsButton) return;

  optionsButton.classList.remove(
    'is-hc-guidance-pulse'
  );

  void optionsButton.offsetWidth;

  optionsButton.classList.add(
    'is-hc-guidance-pulse'
  );

  window.setTimeout(function () {
    optionsButton.classList.remove(
      'is-hc-guidance-pulse'
    );
  }, 1200);
}

function initComparePurchaseOptions(hero, compareMode) {
  var compareGuidanceZone = compareMode.querySelector(
  '[data-hc-compare-atc-guidance-zone]'
);

var compareAddButton = compareMode.querySelector(
  '[data-hc-compare-add-to-cart]'
);

if (compareGuidanceZone && compareAddButton) {

  compareGuidanceZone.addEventListener(
    'mouseenter',
    function () {

      if (!compareAddButton.disabled) return;

      pulseCompareOptionsButton(
        compareMode
      );
    }
  );

  compareGuidanceZone.addEventListener(
    'pointerdown',
    function () {

      if (!compareAddButton.disabled) return;

      pulseCompareOptionsButton(
        compareMode
      );
    }
  );

}
  compareMode.addEventListener('click', function (event) {

    var trigger = event.target.closest(
      '[data-hc-compare-config-trigger]'
    );

    if (trigger) {
      event.preventDefault();

      openCompareOptionsPanel(
        hero,
        compareMode
      );

      return;
    }


    var close = event.target.closest(
      '[data-hc-compare-options-close]'
    );

    if (close) {
      event.preventDefault();

      closeCompareOptionsPanel(compareMode);

      return;
    }


    var colorButton = event.target.closest(
      '[data-hc-compare-purchase-color]'
    );

    if (colorButton) {
      event.preventDefault();

      var panel = colorButton.closest(
        '[data-hc-compare-options-panel]'
      );

      if (!panel) return;

      panel
        .querySelectorAll('[data-hc-compare-purchase-color]')
        .forEach(function (button) {
          button.classList.remove('is-selected');
        });

      colorButton.classList.add('is-selected');


      var selectedSide =
        colorButton.getAttribute(
          'data-hc-compare-purchase-color'
        );

      var side = compareMode.querySelector(
        '.hc-compare-product[data-hc-compare-side="' +
        selectedSide +
        '"]'
      );

      if (!side) return;

      var productId = side.getAttribute(
        'data-hc-compare-product-id'
      );

      var productData =
        getCompareProductData(
          hero,
          productId
        );

      if (!productData) return;


      var done = panel.querySelector(
        '[data-hc-compare-options-done]'
      );

      if (!done) return;


      done.setAttribute(
        'data-product-id',
        productId
      );


      var hasOnlyDefaultVariant =
        productData.getAttribute(
          'data-product-has-only-default-variant'
        ) === 'true';


      if (hasOnlyDefaultVariant) {
  var variantId =
    productData.getAttribute(
      'data-product-default-variant-id'
    );

  done.setAttribute(
    'data-variant-id',
    variantId
  );

  done.disabled = false;

  done.setAttribute(
    'aria-disabled',
    'false'
  );

} else {

  done.removeAttribute(
    'data-variant-id'
  );

  done.disabled = true;

  done.setAttribute(
    'aria-disabled',
    'true'
  );

  buildCompareDynamicOptions(
    panel,
    productData
  );
}

return;
    }

    var optionButton = event.target.closest(
  '[data-hc-compare-dynamic-option-value]'
);

if (optionButton) {
  event.preventDefault();

  var panel = optionButton.closest(
    '[data-hc-compare-options-panel]'
  );

  if (!panel) return;

  var group = optionButton.closest(
    '[data-hc-compare-dynamic-option-group]'
  );

  if (!group) return;

  group
    .querySelectorAll(
      '[data-hc-compare-dynamic-option-value]'
    )
    .forEach(function (button) {
      button.classList.remove(
        'is-selected'
      );
    });

  optionButton.classList.add(
    'is-selected'
  );


  var productId =
    panel
      .querySelector(
        '[data-hc-compare-options-done]'
      )
      .getAttribute(
        'data-product-id'
      );

  var productData =
    getCompareProductData(
      hero,
      productId
    );

  updateCompareOptionsDoneState(
    panel,
    productData
  );

  return;
}

    var doneButton = event.target.closest(
      '[data-hc-compare-options-done]'
    );

    if (doneButton) {
      event.preventDefault();

      if (doneButton.disabled) return;

      var productId =
        doneButton.getAttribute(
          'data-product-id'
        );

      var variantId =
        doneButton.getAttribute(
          'data-variant-id'
        );

      if (!productId || !variantId) return;


      compareMode.setAttribute(
        'data-hc-purchase-product-id',
        productId
      );

      compareMode.setAttribute(
        'data-hc-purchase-variant-id',
        variantId
      );

      var selectedColorButton =
  doneButton
    .closest('[data-hc-compare-options-panel]')
    .querySelector(
      '[data-hc-compare-purchase-color].is-selected'
    );

if (selectedColorButton) {
  var selectedSide =
    selectedColorButton.getAttribute(
      'data-hc-compare-purchase-color'
    );

  confirmComparePurchaseSide(
    compareMode,
    selectedSide
  );
}

      var addButton =
        compareMode.querySelector(
          '[data-hc-compare-add-to-cart]'
        );

      var addText =
        compareMode.querySelector(
          '[data-hc-compare-add-to-cart-text]'
        );

      if (addButton) {
        addButton.disabled = false;
        addButton.setAttribute(
          'aria-disabled',
          'false'
        );
      }

      if (addText) {
  addText.textContent =
    'ADD TO BAG';
}

closeCompareOptionsPanel(
  compareMode
);
}

var personalizeButton = event.target.closest(
  '[data-hc-compare-personalize]'
);

if (personalizeButton) {
  event.preventDefault();

  var personalizePopup =
    document.getElementById('personalize-popup');

  if (!personalizePopup) return;

  if (personalizePopup.parentElement !== document.body) {
    document.body.appendChild(personalizePopup);
  }

  personalizePopup.style.display = 'block';
  personalizePopup.style.zIndex = '2147483647';

  document.body.classList.add(
    'hc-personalize-popup-open'
  );


  if (
    personalizePopup.getAttribute(
      'data-hc-compare-personalization-ready'
    ) !== 'true'
  ) {

    personalizePopup.setAttribute(
      'data-hc-compare-personalization-ready',
      'true'
    );


    personalizePopup.addEventListener(
      'click',
      function (popupEvent) {

        var closeButton =
          popupEvent.target.closest('.close-btn');

        if (closeButton) {
          popupEvent.preventDefault();
          popupEvent.stopPropagation();

          personalizePopup.style.display = 'none';

          document.body.classList.remove(
            'hc-personalize-popup-open'
          );

          return;
        }


        var doneButton =
          popupEvent.target.closest(
            '.hc-popup-method-layout .btn.btn-default.close'
          );

        if (doneButton) {
          popupEvent.preventDefault();
          popupEvent.stopPropagation();

          var initialsInput =
            personalizePopup.querySelector(
              '#personalized_initials'
            );

          var initials =
            initialsInput
              ? initialsInput.value.trim()
              : '';

          var method = '';

          var radios =
            personalizePopup.querySelectorAll(
              'input[name="method"]'
            );

          for (var i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
              method = radios[i].value;
              break;
            }
          }


          if (initials !== '' && method === '') {
            alert(
              'Please choose a personalization method before continuing.'
            );

            return;
          }


          if (initials === '' && method !== '') {
            alert(
              'Please enter your initials or wording to complete your personalization.'
            );

            return;
          }


          var hiddenInitials =
            document.getElementById(
              'hidden_initials'
            );

          var hiddenMethod =
            document.getElementById(
              'hidden_method'
            );


          if (hiddenInitials) {
            hiddenInitials.value = initials;
            hiddenInitials.disabled = false;
          }


          if (hiddenMethod) {
            hiddenMethod.value = method;
            hiddenMethod.disabled = false;
          }


          personalizePopup.style.display = 'none';

          document.body.classList.remove(
            'hc-personalize-popup-open'
          );

          return;
        }


        if (popupEvent.target === personalizePopup) {
          personalizePopup.style.display = 'none';

          document.body.classList.remove(
            'hc-personalize-popup-open'
          );
        }

      }
    );

  }

  return;
}

var exitButton = event.target.closest(
  '[data-hc-compare-exit]'
);

if (exitButton) {
  event.preventDefault();

  var leftProductUrl =
    compareMode.getAttribute(
      'data-hc-compare-product-a-url'
    );

  if (!leftProductUrl) return;

  window.location.href = leftProductUrl;

  return;
}

var compareAddButton = event.target.closest(
  '[data-hc-compare-add-to-cart]'
);

if (compareAddButton) {
  event.preventDefault();

  if (compareAddButton.disabled) {
    pulseCompareOptionsButton(
      compareMode
    );

    return;
  }

  submitCompareProduct(
    hero,
    compareMode
  );

  return;
}

});
}

  function initCompareColorSelection(hero, compareMode) {

    compareMode.addEventListener('mouseover', function (event) {
      var swatch =
        event.target.closest('[data-hc-compare-color-swatch]');

      if (!swatch || swatch.disabled) return;

      var productId =
        swatch.getAttribute('data-product-id');

      preloadCompareProduct(hero, productId);
    });


    compareMode.addEventListener('click', function (event) {
      var swatch =
        event.target.closest('[data-hc-compare-color-swatch]');

      if (!swatch) return;
      if (swatch.disabled) return;

      event.preventDefault();

      var sideName =
        swatch.getAttribute('data-hc-compare-side');

      var productId =
        swatch.getAttribute('data-product-id');

      if (!sideName || !productId) return;

      changeCompareProduct(
        hero,
        compareMode,
        sideName,
        productId
      );
    });
  }


  /* =========================================================
     COLOR CAROUSELS
     ========================================================= */

  function initCompareColorCarousels(compareMode) {
    compareMode
      .querySelectorAll('[data-hc-compare-color-carousel]')
      .forEach(function (carousel) {

        var viewport =
          carousel.querySelector(
            '[data-hc-compare-color-viewport]'
          );

        var prev =
          carousel.querySelector(
            '[data-hc-compare-color-prev]'
          );

        var next =
          carousel.querySelector(
            '[data-hc-compare-color-next]'
          );

        var swatches =
          carousel.querySelectorAll(
            '[data-hc-compare-color-swatch]'
          );

        if (!viewport || !prev || !next || !swatches.length) return;


        if (swatches.length <= 6) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }


        function getStep() {
          var first = swatches[0];

          if (!first) return 60;

          var column = first.parentElement;
          var styles = window.getComputedStyle(column);

          var gap =
            parseFloat(
              styles.rowGap ||
              styles.gap ||
              8
            ) || 8;

          return first.offsetHeight + gap;
        }


        function updateArrows() {
          var maxScroll =
            viewport.scrollHeight -
            viewport.clientHeight -
            2;

          prev.disabled =
            viewport.scrollTop <= 2;

          next.disabled =
            viewport.scrollTop >= maxScroll;
        }


        prev.addEventListener('click', function () {
          viewport.scrollBy({
            top: -getStep(),
            behavior: 'smooth'
          });
        });


        next.addEventListener('click', function () {
          viewport.scrollBy({
            top: getStep(),
            behavior: 'smooth'
          });
        });


        viewport.addEventListener(
          'scroll',
          updateArrows,
          { passive: true }
        );

        updateArrows();
      });
  }


  /* =========================================================
     COMPARE PRODUCT GALLERY CLICKS
     ========================================================= */

  function initCompareGallery(compareMode) {
    compareMode.addEventListener('click', function (event) {

      var thumb =
        event.target.closest('[data-hc-compare-thumb]');

      if (!thumb) return;


      var side =
        thumb.closest('.hc-compare-product');

      if (!side) return;


      event.preventDefault();

      setCompareMedia(side, thumb);
    });
  }


  /* =========================================================
     INITIALIZE COMPARE MODE
     ========================================================= */

  function initHcCompareMode() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    document
      .querySelectorAll('[data-hc-luxury-hero]')
      .forEach(function (hero) {

        if (
          hero.dataset.hcCompareInitialized === 'true'
        ) {
          return;
        }


        var trigger =
          hero.querySelector(
            '[data-hc-compare-trigger]'
          );

        var compareMode =
          hero.querySelector(
            '[data-hc-compare-mode]'
          );


        if (!trigger || !compareMode) return;


        hero.dataset.hcCompareInitialized = 'true';


        initCompareGallery(compareMode);

        initCompareColorCarousels(compareMode);

        initCompareColorSelection(
          hero,
          compareMode
        );

        initComparePurchaseOptions(
          hero,
          compareMode
        );

        trigger.addEventListener(
          'mouseenter',
          function () {
            preloadCompareImages(compareMode);
          }
        );


        trigger.addEventListener(
          'focus',
          function () {
            preloadCompareImages(compareMode);
          }
        );


        trigger.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            preloadCompareImages(compareMode);

            compareMode.hidden = false;

compareMode.setAttribute(
  'aria-hidden',
  'false'
);

hero.classList.add(
  'is-hc-compare-mode'
);

resetComparePurchaseState(compareMode);

window.requestAnimationFrame(function () {
  compareMode
    .querySelectorAll('[data-hc-compare-color-carousel]')
    .forEach(function (carousel) {

      var viewport = carousel.querySelector(
        '[data-hc-compare-color-viewport]'
      );

      var prev = carousel.querySelector(
        '[data-hc-compare-color-prev]'
      );

      var next = carousel.querySelector(
        '[data-hc-compare-color-next]'
      );

      if (!viewport || !prev || !next) return;

      var maxScroll =
        viewport.scrollHeight -
        viewport.clientHeight -
        2;

      prev.disabled =
        viewport.scrollTop <= 2;

      next.disabled =
        viewport.scrollTop >= maxScroll;
    });
});

          }
        );

      });
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initHcCompareMode
    );
  } else {
    initHcCompareMode();
  }


  document.addEventListener(
    'shopify:section:load',
    initHcCompareMode
  );

})();